module.exports = __webpack_public_path__ + "57b82ae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/feature_lightbox4_en@2x.png
// module id = 1038
// module chunks = 0